"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _formatMessage = _interopRequireDefault(require("../format-message"));

var _wcagElementContrast = _interopRequireDefault(require("wcag-element-contrast"));

var _dom = require("../utils/dom");

var _rgbHex = _interopRequireDefault(require("../utils/rgb-hex"));

var _default = {
  id: "small-text-contrast",
  test: (elem, config = {}) => {
    const disabled = config.disableContrastCheck == true;
    const noText = !(0, _dom.hasTextNode)(elem);

    if (disabled || noText || (0, _dom.onlyContainsLink)(elem) || _wcagElementContrast.default.isLargeText(elem)) {
      return true;
    }

    return (0, _wcagElementContrast.default)(elem);
  },
  data: elem => {
    const styles = window.getComputedStyle(elem);
    return {
      color: styles.color
    };
  },
  form: () => [{
    label: (0, _formatMessage.default)("Change text color"),
    dataKey: "color",
    color: true
  }],
  update: (elem, data) => {
    elem.style.color = data.color;
    const styles = (0, _dom.splitStyleAttribute)(elem.getAttribute("data-mce-style") || "");

    if (data && data.color && data.color.indexOf("#") < 0) {
      styles.color = `#${(0, _rgbHex.default)(data.color)}`;
    } else {
      styles.color = data.color;
    }

    elem.setAttribute("data-mce-style", (0, _dom.createStyleString)(styles));
    return elem;
  },
  message: () => (0, _formatMessage.default)("Text smaller than 18pt (or bold 14pt) should display a minimum contrast ratio of 4.5:1."),
  why: () => (0, _formatMessage.default)("Text is difficult to read without sufficient contrast between the text and the background, especially for those with low vision."),
  link: "https://www.w3.org/TR/WCAG20-TECHS/G17.html",
  linkText: () => (0, _formatMessage.default)("Learn more about color contrast")
};
exports.default = _default;